import {
  DailyDeliveryOrdersSummary,
  DailyPickupsSummary,
  ParcelsLineHaulCount,
  RegionOrderCount,
  RegionZoneIntervalOrderCount,
} from '../types/statsTypes';
import Fetch from '../utils/fetch';
import { settings } from '../settings';
import dayjs, { Dayjs } from 'dayjs';
import { VolumesReportInterface } from '../pages/reports/VolumesReport/VolumesReport.types';
import { OrderPredictionDataset } from '../types/orderTypes';
import { queryStringFromObject } from '../utils/urlUtil';

const dateFormat = 'YYYY-MM-DD';
const statsPath = 'stats';

export const fetchOrderCountRegion = async (
  date: string
): Promise<RegionZoneIntervalOrderCount[]> => {
  try {
    const response = await Fetch.get({
      url: `${settings.newApiUrl}/${statsPath}/regions?date=${date}`,
    });
    return response.ok ? await response.json() : [];
  } catch (e) {
    console.log('Error fetching region order count info', e);
    return [];
  }
};

export const fetchOrdersToSortCount = async (
  deliveryDate: Dayjs
): Promise<RegionOrderCount[]> => {
  try {
    const date = deliveryDate.format(dateFormat);
    const response = await Fetch.get({
      url: `${settings.newApiUrl}/${statsPath}/sort-count?date=${date}`,
    });
    return response.ok ? await response.json() : [];
  } catch (e) {
    console.log('Error fetching region orders to sort count info', e);
    return [];
  }
};

export async function fetchDeliveriesByAccount(
  startDate: Date,
  endDate: Date
): Promise<VolumesReportInterface> {
  const start = dayjs(startDate).format(dateFormat);
  const end = dayjs(endDate).format(dateFormat);
  const response = await Fetch.get({
    url: `${settings.newApiUrl}/${statsPath}/deliveries-by-account?start=${start}&end=${end}`,
  });
  return response.json();
}

export async function fetchPredictionData(
  startDate: Dayjs,
  endDate: Dayjs
): Promise<OrderPredictionDataset[]> {
  const queryParams = {
    start: dayjs(startDate).format(dateFormat),
    end: dayjs(endDate).format(dateFormat),
  };
  const queryString = queryStringFromObject(queryParams);
  const response = await Fetch.get({
    url: `${settings.newApiUrl}/${statsPath}/order/prediction${queryString}`,
  });
  return response.json();
}

export async function fetchDeliveryOrdersSummary(
  start: Dayjs,
  end: Dayjs
): Promise<DailyDeliveryOrdersSummary> {
  const startDate = start.format(dateFormat);
  const endDate = end.format(dateFormat);
  const response = await Fetch.get({
    url: `${settings.newApiUrl}/${statsPath}/deliveries-summary?start=${startDate}&end=${endDate}`,
  });

  if (response.ok) {
    return (await response.json()) as DailyDeliveryOrdersSummary;
  } else {
    return {
      ordersSizeCount: {
        dailyTotal: 0,
        xxl: 0,
        temperatureCount: 0,
      },
      ordersBundlesCount: {
        openDeviationCount: 0,
        bundleCount: 0,
        openBundledDeviationCount: 0,
      },
      accounts: [],
    };
  }
}

export async function fetchDailyPickupsSummary(
  pickupDate: Dayjs
): Promise<DailyPickupsSummary> {
  const date = pickupDate.format(dateFormat);
  const response = await Fetch.get({
    url: `${settings.newApiUrl}/${statsPath}/pickups-summary?date=${date}`,
  });

  if (response.ok) {
    return (await response.json()) as DailyPickupsSummary;
  } else {
    return {
      pickupDate: date,
      pickups: [],
    };
  }
}

export async function fetchLineHaulSortingSummary(
  date: string
): Promise<ParcelsLineHaulCount[]> {
  const response = await Fetch.get({
    url: `${settings.newApiUrl}/${statsPath}/lineHaul-scans-summary?date=${date}`,
  });

  if (response.ok) {
    return (await response.json()) as ParcelsLineHaulCount[];
  } else {
    return [];
  }
}
